import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@mui/styles";
import { IconButton, Paper } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import {
  DetalleOpcionGenerica,
  DetalleValoresPorPagar,
  DetalleMovimientosCliente,
  DetalleEstadoCredito,
  DetalleDatosSolicitud,
  DetallePagosTransaccional,
  DetalleDatosSeguros,
  DetalleSiniestros,
  DetalleQuejas,
  DetallePayment,
  DetalleMenuMobile,
} from "../containers";

import SpinnerLoadSrx from "app/modules/shared/components/SpinnerLoadSrx";
import { consultarEstadoCredito } from "../services/transaccionalService";

import { LISTA_OPCIONES } from "../constants/constants";

import { useResolutionScreen } from "../hooks/useResolutionScreen";

import TransaccionalContext from "../context/TransaccionalContext";
import CabeceraCuentaCredito from "../components/CabeceraCuentaCredito";
import HeaderInformacionCliente from "app/modules/shared/containers/HeaderInformacionCliente";

const useStylesButtonColapse = makeStyles((theme) => ({
  buttonColapse: {
    /*  position: "absolute",
    top: "-22px",
    left: "50%",
    transform: "translateX(-50%)", */
    margin: "0.5rem",
    background: "white",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      background: "white",
    },
  },
}));

const DetalleTransaccionalMobile = ({ datosBusqueda, setDatosBusqueda }) => {
  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  const [cabenceraTransaccional, setCabenceraTransaccional] = useState({
    idCuenta: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const styleButtonColapse = useStylesButtonColapse();

  const { alturaResolucion } = useResolutionScreen();

  useEffect(() => {
    console.log(datosBusqueda);

    const getCabeceraTsx = async () => {
      try {
        const respuestaCabeceraTsx = await consultarEstadoCredito(
          datosBusqueda.identificacion,
          datosBusqueda.idGrupo
        );

        /*  console.log(respuestaCabeceraTsx); */

        if (respuestaCabeceraTsx.state) {
          setCabenceraTransaccional(respuestaCabeceraTsx.data);

          setInformacionTransaccional((args) => ({
            ...args,
            identificacion: respuestaCabeceraTsx?.data?.identificacion,
            idCliente: respuestaCabeceraTsx?.data?.idCliente,
            idGrupo: respuestaCabeceraTsx?.data?.idGrupo,
            informacionTransaccional: respuestaCabeceraTsx?.data,
          }));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    getCabeceraTsx();
  }, [informacionTransaccional.updateValidacionPago]);

  if (isLoading) {
    return <SpinnerLoadSrx />;
  }

  if (
    cabenceraTransaccional.idCuenta <= 0 ||
    cabenceraTransaccional.idCuenta === null
  ) {
    return (
      <Paper
        sx={{ width: "70%", padding: "2rem", borderRadius: "25px" }}
        elevation={3}
      >
        Cliente no posee cuenta.!!
      </Paper>
    );
  }

  const handleReturnMenu = () => {
    setDatosBusqueda((args) => ({
      ...args,
      idMovimiento: 0,
      menuMobile: true,
    }));
  };

  return (
    <>
      {!datosBusqueda.menuMobile && (
        <div>
          <IconButton
            className={styleButtonColapse.buttonColapse}
            aria-label="calapse-right"
            size="large"
            onClick={handleReturnMenu}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
        </div>
      )}
      {/*  <HeaderInformacionCliente
        idCliente={cabenceraTransaccional?.idCliente}
        versionEmail={true}
      /> */}

      {datosBusqueda.menuMobile ? (
        <DetalleMenuMobile
          datosBusqueda={datosBusqueda}
          setDatosBusqueda={setDatosBusqueda}
        />
      ) : (
        <div className="movimientoClienteMobile-detalle-items">
          {datosBusqueda.idMovimiento === 0 && (
            <section className="movimientoCliente-informacion">
              <DetalleOpcionGenerica alturaResolucion={alturaResolucion} />
            </section>
          )}

          {datosBusqueda.idMovimiento === LISTA_OPCIONES.ESTADO_CUENTA && (
            <section className="movimientoCliente-informacion">
              <h2 style={{ display: "flex", justifyContent: "center" }}>
                <strong>Estado de Cuenta</strong>
              </h2>
              <DetalleValoresPorPagar
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}

          {datosBusqueda.idMovimiento === LISTA_OPCIONES.MOV_FECHA && (
            <section className="movimientoCliente-informacion">
              <h2 style={{ display: "flex", justifyContent: "center" }}>
                <strong>Mov. a la fecha</strong>
              </h2>
              <DetalleMovimientosCliente
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}

          {datosBusqueda.idMovimiento === LISTA_OPCIONES.ESTADO_CREDITO && (
            <section className="movimientoCliente-informacion">
              <h2 style={{ display: "flex", justifyContent: "center" }}>
                <strong>Consumos</strong>
              </h2>
              <DetalleEstadoCredito
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}

          {datosBusqueda.idMovimiento === LISTA_OPCIONES.ESTADO_SOLICITUD && (
            <section className="movimientoCliente-informacion">
              <DetalleDatosSolicitud
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}

          {datosBusqueda.idMovimiento === LISTA_OPCIONES.PAGOS && (
            <section className="movimientoCliente-informacion">
              <h2 style={{ display: "flex", justifyContent: "center" }}>
                <strong>Pagos</strong>
              </h2>
              <DetallePagosTransaccional
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}
          {datosBusqueda.idMovimiento === LISTA_OPCIONES.DATOS_SEGURO && (
            <section className="movimientoCliente-informacion">
              <h2 style={{ display: "flex", justifyContent: "center" }}>
                <strong>Seguros</strong>
              </h2>
              <DetalleDatosSeguros
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}
          {/* SINIESTROS */}
          {datosBusqueda.idMovimiento === LISTA_OPCIONES.SINIESTROS && (
            <section className="movimientoCliente-informacion">
              <h2 style={{ display: "flex", justifyContent: "center" }}>
                <strong>Siniestros</strong>
              </h2>
              <DetalleSiniestros
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}
          {/* QUEJAS */}
          {datosBusqueda.idMovimiento === LISTA_OPCIONES.QUEJAS && (
            <section className="movimientoCliente-informacion">
              <h2 style={{ display: "flex", justifyContent: "center" }}>
                <strong>Quejas</strong>
              </h2>
              <DetalleQuejas
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}

          {/* PAYMENT */}
          {datosBusqueda?.idMovimiento === LISTA_OPCIONES.PAYMENT && (
            <section className="movimientoCliente-informacion">
              <DetallePayment
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
            </section>
          )}
        </div>
      )}
    </>
  );
};

export default DetalleTransaccionalMobile;
